// extracted by css-extract-rspack-plugin
var _1 = "p8";
var _2 = "ai";
var _3 = "p7";
var _4 = "p6";
var _5 = "gi";
export { _1 as "contextSwitcher", _2 as "hasError", _3 as "loginAndRegistrationForm", _4 as "loginRegistrationWrapperComponent", _5 as "separator" }
